import { render } from "./pharmacy-details.vue?vue&type=template&id=0e2d2be4"
import script from "./pharmacy-details.vue?vue&type=script&lang=js"
export * from "./pharmacy-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__